"use client";
import { forwardRef as e } from "react";
import { jsx as t } from "react/jsx-runtime";
import * as n from "@radix-ui/react-visually-hidden";
//#region src/components/atoms/VisuallyHidden/VisuallyHidden.tsx
var r = e((e, r) => /* @__PURE__ */ t(n.Root, {
	"data-slot": "visually-hidden",
	...e,
	ref: r
}));
r.displayName = "VisuallyHidden";
//#endregion
export { r as VisuallyHidden };
